const $win = $(window);
const $doc = $(document);

$doc
  .on("click", '.form--cart input[type="checkbox"]', function() {
    const $this = $(this);
    const $product = $this.closest("tr");
    const $note = $("#gift-wrap");
    let noteVal = $note.val();

    if ($this.is(":checked")) {
      $note.val(
        `${noteVal}\n${$product.data("product")} - ${$product.data("variant")}`
      );
    } else {
      $note.val(
        noteVal.replace(
          `\n${$product.data("product")} - ${$product.data("variant")}`,
          ""
        )
      );
    }
  })
  .on(
    "change input",
    '.form--cart input[type="checkbox"], #note-holder',
    function(e) {
      const giftWrapVal = $("#gift-wrap").val();
      const noteVal = $("#note-holder").val() || "";

      $("#note").val(`${giftWrapVal}\n---\n${noteVal}`);
    }
  );
